import VaultLanding from "@components/V2/Vault/Landing/index";
import type { NextPage } from "next";
import Head from "next/head";

const ValutPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>
          Gain – Maximize Your DeFi Staking Rewards | Smart Vaults for Restaking
          Crypto
        </title>
        <meta
          name="description"
          content="Gain by Kernel DAO offers actively managed vaults with $150M+ TVL. Optimize your staking rewards with Airdrop Gain, High Gain & Grizzly Gain. Discover the best DeFi staking rewards with restaking."
        ></meta>
      </Head>
      <VaultLanding />
    </>
  );
};

export default ValutPage;
